<template>
  <section class="TcEventsList">
    <nav class="tabs my-5">
      <span class="tab active">Listado</span>
      <span @click="$root.setPage('events-my-calendar')" class="tab">Mis inscripciones</span>
    </nav>
    <div class="container px-10 mx-auto flex justify-center gap-5 pb-5">
      <div class="filter w-1/4">
        <h2 class="font-medium ff-medium text-2xl">Filtrar eventos</h2>
        <ul class="mt-5">
          <li v-for="(category,i) in categories" :key="i" class="mb-5">
            <label class="flex items-center select-none">
              <input @change="filterByCategory($event)" v-model="category.selected"
                class="h-5 w-5 mr-2" type="checkbox">
              <svg class="h-6 w-6 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="category.color"/>
              </svg>
              <span>{{ category.name }}</span>
            </label>
          </li>
        </ul>
      </div>
      <div class="list w-3/4">
        <div class="search flex w-full bg-white p-3 mb-5 gap-5">
          <div class="flex-1">
            <input class="w-full h-full px-3" type="search" placeholder="Buscar" v-model="searchText" @change="filterBySearch($event)">
          </div>
          <div class="flex-1 flex items-center">
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <select v-model="selected_date_ini" class="w-full h-full bg-white" @change="filterBySearch($event)">
              <option value="">Fecha de inicio</option>
              <option v-for="(date,i) in datesIni" :key="i">{{ date }}</option>
            </select>
          </div>
          <div class="flex-1 flex items-center">
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <select v-model="selected_date_end" class="w-full h-full bg-white" @change="filterBySearch($event)">
              <option value="">Fecha de fin</option>
              <option v-for="(date,i) in datesEnd" :key="i">{{ date }}</option>
            </select>
          </div>
          <div class="w-4"></div>
          <button class="px-10 py-3 text-base" @click="filterBySearch($event)">Buscar</button>
        </div>
        <TcEventItem class="mb-3" v-for="(event,i) in events" :key="i" :event="event" :subscribed="IsSubscribed(event)"></TcEventItem>
        <div v-if="events.length==0" class="text-bold text-center">NO SE HAN ENCONTRADO EVENTOS</div>
      </div>
    </div>
    <TcEventShow v-if="selected_event" :event="selected_event"></TcEventShow>
  </section>
</template>

<script>
import TcEventShow from './TcEventShow.vue';
import TcEventItem from './TcEventItem.vue';
import eventsMixin from '../mixin/eventsMixin';

export default {
  name: 'TcEventsList',
  components: {
    TcEventItem,
    TcEventShow,
  },
  data () {
    return {
      events: [],
      categories: [],
      dates: [],
      searchText: '',
      selected_date_ini: '',
      selected_date_end: '',
      selected_event: null,
    }
  },
  mixins: [
    eventsMixin,
  ],
  computed: {
    datesIni: function() {
      //return this.dates;
      if(this.selected_date_end=='') {
        return this.dates;
      } else {
        var de = this.selected_date_end.split('/').reverse().join('');
        return this.dates.filter(cd => {
          return cd.split('/').reverse().join('') <= de;
        });
      }
    },
    datesEnd: function() {
      if(this.selected_date_ini=='') {
        return this.dates;
      } else {
        var di = this.selected_date_ini.split('/').reverse().join('');
        return this.dates.filter(cd => {
          return cd.split('/').reverse().join('') >= di;
        });
      }
    }
  },
  methods: {
    subscribeEvent: function(c_event) {
      this.$root.selected_event = c_event;
      this.$root.setPage('inscription');
    },
    moreInfo: function(event) {
      this.selected_event = event;
    },
    showAllEvents: function() {
      this.events.forEach(function(event) {
        event.filter = true;
      })
    },
    filterBySearch: function() {
      this.events.forEach(e => {
        var filterByName = true;
        if (this.searchText != '')
          filterByName = e.name.toLowerCase().includes( this.searchText.toLowerCase() );

        var filterByStartDate = true;
        if (this.selected_date_ini != '')
          filterByStartDate = this.selected_date_ini.split('/').reverse().join('') <= e.start_date.split('/').reverse().join('') ;

        var filterByEndDate = true;
        if (this.selected_date_end != '')
          filterByEndDate = e.start_date.split('/').reverse().join('')  <= this.selected_date_end.split('/').reverse().join('');

        if ( filterByName  && filterByStartDate && filterByEndDate ) {
          e.show = true;
        } else {
          e.show = false;
        }
      })

    },
    filterByCategory: function() {
      // extraer los filtros
      let filters = this.categories.filter(f => f.selected==true)
      if(filters.length==0) {
        this.showAllEvents();
      } else {
        filters = filters.map(f => f.id);
        this.events.forEach(e => {
          if(filters.indexOf(e.category_id)>=0) {
            e.filter = true;
          } else {
            e.filter = false;
          }
        })
      }
    },
    loadEvents: async function() {
      var catSet = new Set();
      var filters = [];
      this.events = [];
      const procEvents = (e) => {
        if(!catSet.has(e.category_name)) {
          // grupo de fechas
          if(this.dates.indexOf(e.start_date)<0) {
            this.dates.push(e.start_date);
          }
          // grupo de categorías
          catSet.add(e.category_name);
          this.categories.push({
            id: e.category_id,
            color: e.color,
            name: e.category_name,
            selected: false,
          });
        }
        e.show = true;
        e.filter = true;
        return e;
      }
      if(this.$root.user && this.$root.user.external) {
        let url = this.$root.external_events_url();
        filters = await fetch(url).then(response => response.json())
        .then(json => json.map(e => e.id))
        .catch(error => ({
          msg: 'SE HA PRODUCIDO UN ERROR EN TcEventsList@loadEvents',
          error: error,
        }));
      }
      let url = this.$root.events_url();
      return fetch(url).then(response =>response.json()).then(json => {
        this.categories = [];
        this.dates = [];
        if(filters.length > 0) {
          this.events = json.filter(e => filters.indexOf(e.id)>=0).map(procEvents);
        } else {
          this.events = json.map(procEvents);
        }

        // Ordenar categorías y fechas
        this.dates.sort((a,b) => {
          let af = a.split('/').reverse().join('')
          let bf = b.split('/').reverse().join('')
          return af.localeCompare(bf);
        })
        this.categories.sort((a,b) => {
          return a.name.localeCompare(b.name);
        })
      }).catch(err => {
        console.error('SE HA PRODUCIDO UN ERROR EN TcEventsList', err);
      })
    },
  },
  mounted() {
    this.loadMyEvents();
    this.loadEvents();
  }
}
</script>